<template>
  <TooltipIconButton
    icon="mdi-plus"
    tooltipText="tooltip.create"
    :color="color"
    :disabled="disabled"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'CreateButton',
  props: {
    color: {
      type: String,
      default: 'red',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
